import * as Yup from "yup";

import { Dispatch, bindActionCreators } from "redux";
import { Formik, useFormik } from "formik";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { currentStep, isActive } from "../../services/navigation";

import AdesaoActions from "../../store/ducks/adesao";
import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import Loading from "../../components/Loading";
import MenuAside from "../../components/MenuAside";
import { Overlay } from "react-portal-overlay";
import Progresso from "../../components/Progresso";
import RealizePrev from "../../support";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import { connect } from "react-redux";
import moment from "moment";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import translate from "../../i18n";

const top_confimacao = require("../../assets/images/topo_confirmacao.jpg");

interface Props {
  nextStep?: Function;
  previousStep?: Function;
  confirmacaoRequest?: Function;
  inserirBeneficiarioAdesaoRequest?: Function;
  inserirDocumentoAdesaoRequest?: Function;
  solicitaAssinaturaRequest?: Function;
  documentoAssinadoRequest?: Function;
  parametrosConfirmacaoRequest?: Function;
  currentStep: number;
  adesao?: {
    registros: {
      confirmacaoParamtros?: {
        idPasta: string;
        dominioSharePoint: string;
        biblSharePoint: string;
        sharepointArea: string;
      };
      dadosAssinatura?: {
        cpf?: string;
        dataCadastro?: string;
        idDocumento?: string;
        idDocumentoFornecedor?: string;
        idPastaFornecedor?: string;
        statusDocumento?: string;
        status?: string;
        linkSharepoint?: string;
      };
      documentoAssinado?: {
        idDocumento?: string;
        idPastaFornecedor?: string;
        cpf?: string;
        statusDocumento?: string;
        dataCadastro?: string;
        idDocumentoFornecedor?: string;
        linkSharepoint?: string;
      };

      parenteParticipante?: {
        parentesco: [
          {
            idParentesco: number;
            descParentesco: string;
          }
        ];
      };

      associadoEspecial?: {
        instituidor: [
          {
            descPatrocinador: string;
            cnpj: string;
            codPatrocinador: number;
            indPatrocinadorInstituidor: string;
          }
        ];
        plano: [
          {
            descCompleta: string;
            descTipoPlano: string;
            codTipoPlano: number;
            idTipoPlano: number;
          }
        ];
      };

      participante?: {
        instituidor: [
          {
            descPatrocinador: string;
            cnpj: string;
            codPatrocinador: number;
            indPatrocinadorInstituidor: string;
          }
        ];
        plano: [
          {
            descCompleta: string;
            descTipoPlano: string;
            codTipoPlano: number;
            idTipoPlano: number;
          }
        ];
      };

      buscaParticipante: {
        nome: string;
      };
      dadosCadastraisRespFinanceiroEndereco: {
        endereco: {
          descLogradouro: string;
          descBairro: string;
          descCidade: string;
          descUf: string;
          numero: string;
          complemento: string;
          cep: string;
        };
      };
      dadosCadastraisEndereco: {
        endereco: {
          descLogradouro: string;
          descBairro: string;
          descCidade: string;
          descUf: string;
          numero: string;
          complemento: string;
          cep: string;
        };
      };
      dadosAdesao: {
        cpfRespFinanceiro: string;
        cpfParticipanteIndicante: string;
        rgRespFinanceiro: string;
        nomeRespFinanceiro: string;
        nomeSocialRespFinanceiro?: string;
        numeroLogradouro: string;
        complementoLogradouro: string;
        nome: string;
        nomeSocial?: string;
        cpf: string;
        numeroCnh: string;
        rg: string;
        idParentesco: number;
        idPatrocinador: string;
        idPropostaAdesao: number;
        email: string;
        documentos: [];
        idTipoPlano: number;
      };

      dadosCadastrais: {
        pessoa: {
          email: string;
        };
      };

      confirmacao: {
        instituidor: [
          {
            descPatrocinador: string;
            cnpj: string;
            codPatrocinador: number;
            indPatrocinadorInstituidor: string;
          }
        ];
        plano: [
          {
            descCompleta: string;
            descTipoPlano: string;
            codTipoPlano: number;
            idTipoPlano: number;
          }
        ];
        valorMinimoContribuicao: number;
      };
    };

    error: {
      error: string;
      errorConfirmacao: string;
    };
    loading: boolean;
  };
}

interface IDocumento {
  documento?: File;
  documentoBase64: string;
  nomeDocumento?: string;
  codDocumento?: number;
  codInstituidor?: string;
  cpfBeneficiario?: string;
  idPropostaAdesao?: number;
  idUsuarioInclusao?: number;
  dataInclusao?: string;
  idDocumentoAssinado?: string;
  emailAssinatura?: string;
}
const Confirmacao: React.FC<Props> = ({
  nextStep,
  previousStep,
  confirmacaoRequest,
  adesao,
  inserirBeneficiarioAdesaoRequest,
  inserirDocumentoAdesaoRequest,
  solicitaAssinaturaRequest,
  documentoAssinadoRequest,
  parametrosConfirmacaoRequest,
  currentStep,
}) => {
  const [openRespFinanceito, setOpenRespFinanceito] = useState<boolean>(false);
  const [descParentesco, setDescParentesco] = useState("");

  const [documentoGerado, setDocumentoGerado] = useState(false);

  const formSubmit = useRef<any>();

  const [descPlano, setDescPlano] = useState("");
  const [descInstituidor, setDescInstituidor] = useState("");

  useEffect(() => {
    if (adesao?.registros?.dadosAdesao?.idPatrocinador) {
      parametrosConfirmacaoRequest!(
        adesao?.registros?.dadosAdesao.idPatrocinador
      );
    }
  }, [
    parametrosConfirmacaoRequest,
    adesao?.registros.dadosAdesao?.idPatrocinador,
  ]);

  useEffect(() => {
    if (
      adesao?.registros.dadosAdesao?.idPatrocinador &&
      adesao?.registros.dadosAdesao?.idTipoPlano
    ) {
      if (adesao?.registros?.associadoEspecial) {
        setDescInstituidor(
          adesao?.registros.associadoEspecial?.instituidor.map((item: any) => {
            if (
              item.codPatrocinador ===
              adesao?.registros.dadosAdesao.idPatrocinador
            ) {
              return item.descPatrocinador;
            }
          }) as unknown as string
        );

        setDescPlano(
          adesao?.registros.associadoEspecial?.plano.map((item: any) => {
            if (
              item.idTipoPlano === adesao?.registros.dadosAdesao.idTipoPlano
            ) {
              return item.descCompleta;
            }
          }) as unknown as string
        );
      }

      if (adesao?.registros?.participante) {
        setDescInstituidor(
          adesao?.registros.participante?.instituidor.map((item: any) => {
            if (
              item.codPatrocinador ===
              adesao?.registros.dadosAdesao.idPatrocinador
            ) {
              return item.descPatrocinador;
            }
          }) as unknown as string
        );

        setDescPlano(
          adesao?.registros.participante?.plano.map((item: any) => {
            if (
              item.idTipoPlano === adesao?.registros.dadosAdesao.idTipoPlano
            ) {
              return item.descCompleta;
            }
          }) as unknown as string
        );
      }
    }
  }, [
    adesao?.registros.associadoEspecial,
    adesao?.registros.participante,
    adesao?.registros.dadosAdesao,
  ]);

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tipoParticipante = sessionStorage.getItem(
    "@RealizePrev:tipoParticipante"
  );
  const maiorIdadeSession = sessionStorage.getItem("@RealizePrev:maiorIdade");

  const formik = useFormik({
    initialValues: {
      confirmacao: {
        termoAceiteABRAPP: false,
        declaroParticipanteAtivo: false,
        declaroRespFinanceiro: false,
        parenteParticipante: tipoParticipante === "ParenteParticipante",
        menorIdade: maiorIdadeSession === "false",
      },
    },

    validationSchema: Yup.object({
      confirmacao: Yup.object({
        parenteParticipante: Yup.boolean(),
        declaroParticipanteAtivo: Yup.boolean().when("parenteParticipante", {
          is: true,
          then: (s: any) =>
            s
              .required()
              .oneOf(
                [true],
                translate.t("app.mensagem.validacaoDeclareParticipante")
              ),
        }),
        menorIdade: Yup.boolean(),
        declaroRespFinanceiro: Yup.boolean().when("menorIdade", {
          is: true,
          then: (s: any) =>
            s
              .required()
              .oneOf(
                [true],
                translate.t("app.mensagem.validacaoDeclareRespFinanceiro")
              ),
        }),
      }),
    }),
    onSubmit: (values) => {
      if (
        adesao?.registros?.dadosAdesao?.documentos !== undefined &&
        adesao?.registros?.dadosAdesao?.documentos.length > 0
      ) {
        let arrayFormatado = JSON.parse(
          JSON.stringify(adesao?.registros.dadosAdesao.documentos)
        ) as IDocumento[];

        arrayFormatado = arrayFormatado.map((vDocumento: IDocumento) => {
          delete vDocumento.documento;
          return {
            ...vDocumento,
            documentoBase64: vDocumento.documentoBase64.split("base64,")[1],
          } as IDocumento;
        }) as IDocumento[];

        const adesaoAssinada = {
          codDocumento: 14,
          cpfBeneficiario: adesao?.registros.dadosAdesao.cpf, //"08312131400",
          idPropostaAdesao: adesao?.registros.dadosAdesao.idPropostaAdesao, // 6002,
          codInstituidor: adesao?.registros.dadosAdesao.idPatrocinador, //"3",
          idUsuarioInclusao: RealizePrev().idUsuario,
          dataInclusao: moment(new Date()).format("DD/MM/YYYY"),
          documentoBase64: "",
          idDocumentoAssinado:
            adesao?.registros.dadosAssinatura?.idDocumentoFornecedor,
          emailAssinatura: adesao?.registros.dadosAdesao.email, //"rafaelbessa2@gmail.com",
        } as IDocumento;

        arrayFormatado.push(adesaoAssinada);

        inserirDocumentoAdesaoRequest!({
          ...adesao?.registros.dadosAdesao,
          documentos: arrayFormatado,
        });
      }
    },
  });

  function dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  useEffect(() => {
    if (
      currentStep === 7 &&
      !formik.values.confirmacao.parenteParticipante &&
      !formik.values.confirmacao.menorIdade &&
      !documentoGerado
    ) {
      handleGerarDocumentos();
    }
  }, [
    handleGerarDocumentos,
    formik.values.confirmacao.menorIdade,
    formik.values.confirmacao.parenteParticipante,
    currentStep,
    documentoGerado,
  ]);

  const gerarPdfAdesao = async () => {
    if (
      formik.values.confirmacao.menorIdade &&
      !formik.values.confirmacao.declaroRespFinanceiro
    ) {
      formik.setFieldError(
        "confirmacao.declaroRespFinanceiro",
        translate.t("app.mensagem.validacaoDeclareRespFinanceiro")
      );
    } else if (
      formik.values.confirmacao.parenteParticipante &&
      !formik.values.confirmacao.declaroParticipanteAtivo
    ) {
      formik.setFieldError(
        "confirmacao.declaroParticipanteAtivo",
        translate.t("app.mensagem.validacaoDeclareParticipante")
      );
    } else {
      const pdfAdesao = {
        content: {
          table: {
            headerRows: 1,
            widths: ["*"],

            body: [
              [
                {
                  image:
                    "data:image/jpeg;base64,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",
                  width: 500,
                },
              ],
              [
                {
                  text: "PEDIDO DE ASSOCIAÇÃO À ABRAPP",
                  alignment: "center",
                  bold: true,
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: "À Diretoria Integrada do Sistema Abrapp",
                  bold: true,
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: `Eu, ${
                    adesao?.registros?.dadosAdesao?.nomeSocial
                      ? adesao?.registros?.dadosAdesao?.nomeSocial
                      : adesao?.registros?.dadosAdesao?.nome
                  }, portador(a) da cédula de identidade no ${
                    adesao?.registros.dadosAdesao?.rg
                  }, cadastrad(a) no CPF/MF sob o no ${
                    adesao?.registros.dadosAdesao?.cpf
                  }, residente na ${
                    formik.values.confirmacao.menorIdade
                      ? adesao?.registros.dadosCadastraisRespFinanceiroEndereco
                          ?.endereco?.descLogradouro
                      : adesao?.registros.dadosCadastraisEndereco?.endereco
                          ?.descLogradouro
                  }, ${adesao?.registros.dadosAdesao?.numeroLogradouro}, ${
                    adesao?.registros.dadosAdesao?.complementoLogradouro
                  }, ${
                    formik.values.confirmacao.menorIdade
                      ? adesao?.registros.dadosCadastraisRespFinanceiroEndereco
                          ?.endereco?.descBairro
                      : adesao?.registros.dadosCadastraisEndereco?.endereco
                          ?.descBairro
                  }, ${
                    formik.values.confirmacao.menorIdade
                      ? adesao?.registros.dadosCadastraisRespFinanceiroEndereco
                          ?.endereco?.descCidade
                      : adesao?.registros.dadosCadastraisEndereco?.endereco
                          ?.descCidade
                  }, ${
                    formik.values.confirmacao.menorIdade
                      ? adesao?.registros.dadosCadastraisRespFinanceiroEndereco
                          ?.endereco?.descUf
                      : adesao?.registros.dadosCadastraisEndereco?.endereco
                          ?.descUf
                  }, CEP: ${
                    formik.values.confirmacao.menorIdade
                      ? adesao?.registros.dadosCadastraisRespFinanceiroEndereco
                          ?.endereco?.cep
                      : adesao?.registros.dadosCadastraisEndereco?.endereco?.cep
                  }, venho requerer minha filiação ao quadro associativo da Associação Brasileira das Entidades Fechadas de Previdência Complementar, Abrapp na qualidade de Associado Especial Previdenciário ${
                    tipoParticipante === "AssociadoEspecial"
                      ? " Pessoa Física - Vinculado "
                      : " Pessoa Física - Família "
                  }da Abrapp, exclusivamente para fins de inscrição ao Plano de Benefícios Setorial RealizePrev oferecido pela Fachesf.`,
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: ` ${
                    tipoParticipante === "AssociadoEspecial"
                      ? "Ao assinar o presente, declaro estar ciente do inteiro teor do Estatuto Social da ABRAPP, bem como dos direitos e deveres impostos aos seus membros, bem como declaro, para todos os fins e sob as penas da lei, ser segurado do Regime Geral de Previdência Social - RGPS nesta data, ciente de que a falsa declaração resultará na exclusão do quadro associativo."
                      : "Ao assinar o presente termo, declaro estar ciente do inteiro teor do Estatuto Social da Abrapp e dos direitos e deveres impostos aos seus membros."
                  }`,
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: `Autorizo que os dados pessoais aqui informados sejam utilizados para fins de filiação à Abrapp e entendo que os mesmos serão protegidos atendendo ao disposto na Lei nº 13.709/2018.`,
                },
              ],
              [
                {
                  pageBreak: "before",
                  text: "DECLARAÇÃO DE CIÊNCIA",
                  alignment: "center",
                  bold: true,
                },
              ],
              [
                {
                  text: '"REGIME REGRESSIVO"',
                  alignment: "center",
                  bold: true,
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: `Nome do Participante: ${
                    adesao?.registros?.dadosAdesao?.nomeSocial
                      ? adesao?.registros?.dadosAdesao?.nomeSocial
                      : adesao?.registros?.dadosAdesao?.nome
                  }`,
                },
              ],
              [
                {
                  text: `CPF: ${adesao?.registros.dadosAdesao?.cpf}`,
                },
              ],
              [
                {
                  text: `Plano de Benefícios: ${descPlano}`,
                },
              ],
              [
                {
                  text: `Patrocinadora: ${descInstituidor}`,
                },
              ],
              [
                {
                  text: " ",
                },
              ],

              [
                {
                  text: "Declaro estar ciente de que recebi as informações necessárias referente aos Regimes de Tributação aplicáveis e que poderei fazer a opção pelo Regime de Tributação Regressivo, criado pela Lei nº 11.053, de 29 de dezembro de 2004, conforme alterado pela Lei nº 14.803, de 10 de janeiro de 2024, até o momento da obtenção do benefício ou da requisição do primeiro resgate referente aos valores acumulados.",
                },
              ],
              [
                {
                  text: " ",
                },
              ],
              [
                {
                  text: "Não havendo a minha manifestação quando da obtenção do benefício ou da requisição do primeiro resgate, isto será entendido como opção pelas regras vigentes antes da edição da referida lei, sendo, portanto, considerado o Regime de Tributação Progressivo.",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
      };

      const pdfDocGenerator = await pdfMake.createPdf(pdfAdesao);

      pdfDocGenerator.getDataUrl((data) => {
        solicitaAssinaturaRequest!({
          arquivo: dataURLtoFile(
            data,
            "Termo_adesao_realizeprev_" +
              // "08312131400" +
              adesao?.registros.dadosAdesao.cpf
                .replace(".", "")
                .replace("-", "") +
              ".pdf"
          ),

          idPasta: adesao?.registros.confirmacaoParamtros?.idPasta, //"ebcf2d69-7525-40a3-a918-6095b07d8a96",
          cpfSignatario: adesao?.registros.dadosAdesao.cpf
            .replace(".", "")
            .replace("-", ""), //"08312131400",

          emailSignatario: adesao?.registros.dadosAdesao.email, // adesao?.registros.dadosCadastrais.pessoa.email, // "rafaelbessa2@gmail.com",
          sharepointSistema: 18,
          sharepointDominio:
            adesao?.registros.confirmacaoParamtros?.dominioSharePoint,
          //DOMINIO_SHAREPOINT"fachesf-015",
          sharepointArea:
            adesao?.registros.confirmacaoParamtros?.sharepointArea, //Area.INSTITUIDOR.getConstante()
          sharepointBiblioteca:
            adesao?.registros.confirmacaoParamtros?.biblSharePoint,
          //"INSTITUIDOR", BIBL_SHAREPOINT
          sharepointDiretorio: "",
          sharepointMetadado: [
            "cpf_instituidor;STRING;" +
              adesao?.registros.dadosAdesao.cpf
                .replace(".", "")
                .replace("-", ""),
            //"08312131400",
            "cod_instituidor;STRING;" + //"3",
              adesao?.registros.dadosAdesao.idPatrocinador,
            "cod_documento;STRING;9",
          ],
        });
      });
      setDocumentoGerado(true);
    }
  };

  useEffect(() => {
    if (adesao?.registros.dadosAssinatura) {
      //Dispara para a tela de conclusão
      formSubmit.current.dispatchEvent(new Event("submit"));
    }
  }, [adesao?.registros.dadosAssinatura]);

  useEffect(() => {
    formik.setFieldValue(
      "confirmacao.parenteParticipante",
      tipoParticipante === "ParenteParticipante"
    );
    formik.setFieldValue(
      "confirmacao.menorIdade",
      maiorIdadeSession === "false"
    );
  }, [maiorIdadeSession, tipoParticipante]);

  useEffect(() => {
    retornarParticipante(adesao?.registros.dadosAdesao?.idParentesco);
  }, [adesao?.registros.dadosAdesao?.idParentesco]);

  /*useEffect(() => {
    if (adesao?.registros.documentoAssinado?.idDocumentoFornecedor) {
      setDocumentoAssinado(true);
      formSubmit.current.dispatchEvent(new Event("submit"));
    }
  }, [adesao?.registros.documentoAssinado]);*/

  function handleGerarDocumentos() {
    //event.preventDefault();
    gerarPdfAdesao();
  }

  function retornarParticipante(
    idParentesco: number | undefined
  ): string | void {
    if (adesao?.registros?.parenteParticipante) {
      for (
        let index = 0;
        index < adesao?.registros?.parenteParticipante?.parentesco.length;
        index++
      ) {
        if (
          adesao?.registros.parenteParticipante?.parentesco[index]
            .idParentesco === adesao?.registros?.dadosAdesao?.idParentesco
        ) {
          setDescParentesco(
            adesao?.registros.parenteParticipante?.parentesco[index]
              .descParentesco
          );
        }
      }
    }
  }
  return (
    <Fragment>
      <Overlay
        style={{ background: "rgba(0, 0, 0, 0.5)" }}
        open={openRespFinanceito}
        onClose={() => setOpenRespFinanceito(false)}
      >
        <div
          className="modal-dialog modal-lg  modal-dialog-centered"
          role="document"
          style={{ width: "100%" }}
        >
          <div className="modal-content border-info">
            <div className="modal-body">
              <div className="pl-lg-4 pr-lg-4 pb-4">
                <form className="img-fluid">
                  <table
                    cellSpacing="0"
                    cellPadding="0"
                    style={{ maxWidth: "700px", backgroundColor: "#FFFFFF" }}
                  >
                    <tr>
                      <td>
                        <img
                          src={top_confimacao}
                          style={{ width: "100%", maxWidth: "700px" }}
                          alt="RealizePrev"
                          title="RealizePrev"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{
                            padding: "30px",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <strong>
                              DECLARAÇÃO DE PARENTESCO <br />
                              PARTICIPANTE MENOR DE IDADE
                            </strong>
                          </div>
                          <br />
                          <br />
                          <b>
                            À Fundação Chesf de Assistência e Seguridade Social
                            - Fachesf
                          </b>
                          <br />
                          <br />
                          Eu,{" "}
                          {adesao?.registros.dadosAdesao
                            ?.nomeSocialRespFinanceiro
                            ? adesao?.registros.dadosAdesao
                                ?.nomeSocialRespFinanceiro
                            : adesao?.registros.dadosAdesao?.nomeRespFinanceiro}
                          , portador(a) da cédula de identidade no{" "}
                          {adesao?.registros.dadosAdesao?.rgRespFinanceiro},
                          cadastrado(a) no CPF no{" "}
                          {adesao?.registros.dadosAdesao?.cpfRespFinanceiro},
                          residente na{" "}
                          {
                            adesao?.registros
                              .dadosCadastraisRespFinanceiroEndereco?.endereco
                              ?.descLogradouro
                          }
                          , {adesao?.registros.dadosAdesao?.numeroLogradouro},{" "}
                          {adesao?.registros.dadosAdesao?.complementoLogradouro}
                          ,{" "}
                          {
                            adesao?.registros
                              .dadosCadastraisRespFinanceiroEndereco?.endereco
                              ?.descBairro
                          }
                          ,{" "}
                          {
                            adesao?.registros
                              .dadosCadastraisRespFinanceiroEndereco?.endereco
                              ?.descCidade
                          }
                          ,{" "}
                          {
                            adesao?.registros
                              .dadosCadastraisRespFinanceiroEndereco?.endereco
                              ?.descUf
                          }
                          , CEP:{" "}
                          {
                            adesao?.registros
                              .dadosCadastraisRespFinanceiroEndereco?.endereco
                              ?.cep
                          }
                          , por meio do presente venho declarar que o(a) menor
                          de idade{" "}
                          {adesao?.registros?.dadosAdesao?.nomeSocial
                            ? adesao?.registros?.dadosAdesao?.nomeSocial
                            : adesao?.registros?.dadosAdesao?.nome}
                          , cadastrado(a) no CPF no{" "}
                          {adesao?.registros.dadosAdesao?.cpf}, é{" "}
                          {descParentesco} do Participante Fachesf{" "}
                          {adesao?.registros.buscaParticipante?.nome},
                          cadastrado(a) no CPF no{" "}
                          {
                            adesao?.registros.dadosAdesao
                              ?.cpfParticipanteIndicante
                          }
                          , e, como tal, solicito sua inscrição ao Plano de
                          Benefícios Setorial RealizePrev oferecido pela
                          Fachesf.
                          <br />
                          <br />
                          Além disso, declaro que serei o responsável financeiro
                          do(a) Participante menor de idade e caberá a mim
                          realizar todas as contribuições relativas ao custeio
                          do plano, conforme Regulamento.
                          <br />
                          <br />
                          Ao aceitar o presente termo, estou ciente de que a
                          qualquer momento poderei ser chamado(a) pela Fachesf
                          para comprovar os termos desta declaração.
                        </div>
                      </td>
                    </tr>
                  </table>

                  <div className="row">
                    <div className="col-lg-12 text-right">
                      <button
                        type="button"
                        className="btn btn--primary"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          setOpenRespFinanceito(false);
                          formik.setFieldValue(
                            "confirmacao.declaroRespFinanceiro",
                            false
                          );
                        }}
                      >
                        CANCELAR
                      </button>{" "}
                      <button
                        type="button"
                        className="btn btn--primary"
                        onClick={() => {
                          setOpenRespFinanceito(false);
                          formik.setFieldValue(
                            "confirmacao.declaroRespFinanceiro",
                            true
                          );
                        }}
                      >
                        ACEITAR
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Overlay>

      <div className="content wrapper">
        <MenuAside step={5} />
        <form ref={formSubmit} onSubmit={formik.handleSubmit}>
          <div className="container">
            <h2>{translate.t("app.tela.confirmacao.titulo")}</h2>
            {adesao?.loading ? (
              <Loading />
            ) : (
              <Fragment>
                <div className="pt-5 pb-4  mb-4 mt-4">
                  <div
                    className="row"
                    style={{
                      marginTop: "1.2rem",
                    }}
                  >
                    <div className="col-lg-12">
                      {formik.values.confirmacao.parenteParticipante && (
                        <div className="mb-3">
                          <div className="d-flex align-items-center">
                            <label className="wrap-checkbox">
                              {" "}
                              <strong>
                                {translate.t(
                                  "app.tela.confirmacao.label.parenteParticipante"
                                )}
                              </strong>
                              <input
                                type="checkbox"
                                name="confirmacao.declaroParticipanteAtivo"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                checked={
                                  formik.values.confirmacao
                                    .declaroParticipanteAtivo
                                }
                              />
                              <span className="check"></span>
                            </label>
                          </div>
                          <label className="wrap-checkbox">
                            <Error
                              error={
                                formik.errors.confirmacao
                                  ?.declaroParticipanteAtivo
                              }
                            />
                          </label>
                        </div>
                      )}

                      {formik.values.confirmacao.menorIdade && (
                        <div className="mb-3">
                          <div className="d-flex align-items-center">
                            <label className="wrap-checkbox">
                              {" "}
                              <strong>
                                {translate.t(
                                  "app.tela.confirmacao.label.responsavelFinanceiroMenorIdade"
                                )}
                              </strong>
                              <input
                                type="checkbox"
                                name="confirmacao.declaroRespFinanceiro"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                checked={
                                  formik.values.confirmacao
                                    .declaroRespFinanceiro
                                }
                                onClick={() => {
                                  setOpenRespFinanceito(true);
                                }}
                              />
                              <span className="check"></span>
                            </label>
                          </div>
                          <label className="wrap-checkbox">
                            <Error
                              error={
                                formik.errors.confirmacao?.declaroRespFinanceiro
                              }
                            />
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="membership__pagination text-center mt-3">
                  <Error error={adesao?.error.errorConfirmacao} />
                </div>
                <div className="membership__pagination text-center mt-3">
                  <Button
                    previousStep={previousStep ? previousStep : () => {}}
                  />
                  <Button
                    avancarIcon
                    avancar={false}
                    previousStep={handleGerarDocumentos}
                  />
                </div>{" "}
              </Fragment>
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Confirmacao);
